import { useNavigate, useParams } from 'react-router-dom'

import {
  TrainingsCategoryMapConfigCategoryEnum,
  TrainingsCategoryMapConfigDocument,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CategoryConfigItemMapping } from 'modules/trainings/components/Settings/FundaeSubsidySection/CategoryConfigItemMapping'

const MatchDataModal = ({ category }: { category: TrainingsCategoryMapConfigCategoryEnum }) => {
  const { loading, data } = useQuery(TrainingsCategoryMapConfigDocument)
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id } = useParams()

  if (loading) return null

  return (
    <CategoryConfigItemMapping
      categoryMapConfigs={data?.trainings.categoryMapConfigsConnection.nodes ?? []}
      fields={
        category === 'professionalcategory'
          ? data?.contracts.spanishProfessionalCategoriesConnection.nodes ?? []
          : data?.contracts.spanishEducationLevelsConnection.nodes ?? []
      }
      category={category}
      closeModal={() => {
        navigate(navigation.trainings.list.details_revamp.view.fundae.fullPath({ id: String(id) }))
      }}
    />
  )
}

export default MatchDataModal
